<template>
  <div class="sideBar">
    <div class="col-md-4 col-sm-12">
      <div class="garden-sidebar">
        <!-- <div class="sidebar-search">
          <form id="search_sidebar" @submit.prevent="doSearch" method="post">
            <div class="position-relative">
              <input type="text" name="search" v-model="search" :placeholder="`${$t('search')}`" />
              <button type="button" name="btn-search">
                <span class="fa fa-search"></span>
              </button>
            </div>
          </form>
        </div>-->

        <div class="sidebar-box sidebar-portfolio" v-if="categories">
          <h3>{{ $t('categories') }}</h3>
          <ul>
            <li v-for="(category, index) in categories" :key="index">
              <a :href="`/${$i18n.locale}/search-results/${category.name}`">
                <span class="fa fa-angle-right"></span>
                <p>{{ category.name }}</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="sidebar-box sidebar-portfolio" v-if="tags">
          <h3>Tags</h3>
          <div class="tags">
            <div v-for="(tag, index) in tags" :key="index">
              <p class="tag">{{ tag.tag }}</p>
            </div>
          </div>
        </div>
        <div class="sidebar-box sidebar-document">
          <h3>{{ $t('latestNews') }}</h3>
          <ul>
            <li
              v-for="(news, index) in latestNews"
              :key="index"
              class="article"
            >
              <p>{{ news.title }}</p>
              <router-link
                :to="{
                  name: 'SinglePost',
                  params: {
                    type: 'posts',
                    slug: `${news.slug}`
                  }
                }"
                class="readMore"
              >
                <i class="fa fa-eye"></i>
                {{ $t('readMore') }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="sidebar-box sidebar-document">
          <h3>{{ $t('latestBlogs') }}</h3>
          <ul v-if="latestBlogs">
            <li
              v-for="(blog, index) in latestBlogs"
              :key="index"
              class="article"
            >
              <p>{{ blog.title }}</p>
              <router-link
                :to="{
                  name: 'SinglePost',
                  params: {
                    type: 'blog',
                    slug: `${blog.slug}`
                  }
                }"
                class="readMore"
              >
                <i class="fa fa-eye"></i>
                {{ $t('readMore') }}
              </router-link>
            </li>
          </ul>
        </div>
        <!-- <div class="sidebar-box sidebar-document">
          <h3>{{ $t("latestProjects") }}</h3>
          <ul>
            <li v-for="(project,index) in latestProjects" :key="index" class="article">
              <p>{{project.title}}</p>
              <router-link
                :to="{
                        name: 'SinglePost',
                        params: {
                          type: 'project',
                          slug: `${project.slug}`
                        }
                      }"
                class="readMore"
              >
                <i class="fa fa-eye"></i>
                {{ $t('readMore') }}
              </router-link>
            </li>
          </ul>
        </div>-->
        <div class="sidebar-box sidebar-document">
          <h3>{{ $t('brochureText') }}</h3>
          <ul>
            <li class="article">
              <p>
                <i class="fa fa-file-text-o"></i>
                {{ $t('brochureText') }}
              </p>
              <a class="readMore" :href="brochure" target="_blank">
                <i class="fa fa-download"></i>
                {{ $t('brochureButtonTitle') }}
              </a>
            </li>
          </ul>
        </div>
        <!-- <div class="sidebar-banner">
          <div class="garden-img-full-width">
            <img
              src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577371842/afrikeveil/brochureBack.png"
              alt
            />
          </div>
          <div class="text text-center">
            <h2>{{ $t("brochureText") }}</h2>
            <a href="#">
              <i class="fa fa-download"></i>
              {{ $t("brochureButtonTitle") }}
            </a>
          </div>
        </div>-->

        <div class="sidebar-box sidebar-document">
          <h3>Facebook</h3>
          <div
            class="fb-page"
            data-href="https://www.facebook.com/afrikeveil.org/"
            data-tabs="timeline"
            data-width="300"
            data-height="100"
            data-small-header="ture"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="true"
          >
            <blockquote
              cite="https://www.facebook.com/afrikeveil.org/"
              class="fb-xfbml-parse-ignore"
            >
              <a href="https://www.facebook.com/afrikeveil.org/">AFRIK EVEIL</a>
            </blockquote>
          </div>
        </div>
        <div class="sidebar-box sidebar-document">
          <h3>Follow @A_eveil</h3>
          <div class="sb-it archive">
            <br />
            <div class="sb-content">
              <a
                class="twitter-timeline"
                href="https://twitter.com/A_eveil"
                data-width="300"
                data-height="500"
              ></a>
              <a
                class="twitter-follow-button"
                href="https://twitter.com/A_eveil"
                data-size="large"
                >Follow @A_eveil</a
              >
            </div>
          </div>
          <ul>
            <li></li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import APPURL from '../constant';
export default {
  watch: {
    $route() {
      this.getBlogs();
      this.getNews();
      this.getInfo();
      //this.getProjects();
    }
  },
  computed: {
    latestBlogs() {
      let latestBlogs = this.blogs;
      return latestBlogs;
    },
    latestNews() {
      let latestNews = this.news;
      return latestNews;
    },
    brochure() {
      if (this.info[0]) {
        if (this.info[0].brochureAttachment) {
          return this.info[0].brochureAttachment;
        }
      }
      return '';
    }
    // latestProjects() {
    //   let latestProjects = this.projects;
    //   return latestProjects;
    // }
  },
  mounted() {
    this.getBlogs();
    this.getNews();
    this.getInfo();
    //this.getProjects();
  },
  data() {
    return {
      search: '',
      ourNews: {},
      blogs: {},
      news: {},
      projects: {},
      info: {}
    };
  },
  methods: {
    getBlogs(url = APPURL.LINK + 'blogs/' + this.$i18n.locale + '/1/3') {
      Axios.get(url).then(response => {
        this.blogs = response.data.data.results.posts;
      });
    },
    getNews(url = APPURL.LINK + 'posts/' + this.$i18n.locale + '/1/3') {
      Axios.get(url).then(response => {
        this.news = response.data.data.results.posts;
      });
    },
    getInfo(url = APPURL.LINK + 'settings/' + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.info = response.data.data.results;
        //console.log('info', response.data.data.results);
      });
    },
    // getProjects(
    //   url = (url =
    //     "https://api.afrikeveil.org/v1/projects/" + this.$i18n.locale + "/1/3")
    // ) {
    //   Axios.get(url).then(response => {
    //     this.projects = response.data.data.results.posts;
    //   });
    // },

    doSearch() {
      //this.ourNews = { search: this.search };
      // console.log(this.search);
      // console.log(this.ourNews);
    }
  },
  name: 'sideBar',
  props: {
    categories: {},
    tags: {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sidebar-banner img {
  max-height: 400px;
}
.article {
  background-color: #f0f0f0;
  margin-bottom: 20px !important;
  border: 1px solid#c7c7c7b7;
  padding: 10px;
  border-radius: 15px;
}
.article:hover {
  background-color: #e2e3e5;
  border: 1px solid#383d41;
}
.sidebar-box h3 {
  font-size: 18px !important;
  font-weight: bold !important;
}
.article p,
.article1 p {
  font-size: 13px !important;
  font-weight: bold !important;
  margin-bottom: 15px !important;
  margin-top: 15px !important;
}
.readMore {
  font-weight: bold !important;
  font-size: 14px !important;
  background-color: #cce5ff;
  border: 1px solid#b8daff;
  color: #004085 !important;
  padding: 2px 10px;
  border-radius: 5px;
  text-align: center;
}
.readMore:hover {
  font-weight: bold !important;
  font-size: 14px !important;
  background-color: #d4edda;
  border: 1px solid#8ac799;
  color: #155724 !important;
  padding: 2px 10px;
  border-radius: 5px;
  text-align: center;
}
.tags {
  min-height: 50px;
}
.tag {
  background-color: #d4edda;
  float: left;
  border: 1px solid#8ac799;
  padding: 2px 10px;
  margin: 4px;
  color: #155724;
  border-radius: 5px;
  text-align: center;
}
.garden-img-full-width,
.garden-img-full-width img {
  margin-bottom: 50px;
  border-radius: 8px;
}
.garden-sidebar {
  padding: 30px;
  border-radius: 10px;
  -webkit-box-shadow: 0 0 54px rgba(0, 0, 0, 0.11);
  box-shadow: 0 0 54px rgba(0, 0, 0, 0.11);
  border-bottom: 5px solid #fff;
}
.sidebar-box {
  border-radius: 15px;
  border: 1px solid #e9e9e9;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
}
.text h2 {
  font-size: 30px;
  line-height: 60px;
  font-weight: bold;
}
.text a {
  font-size: 25px;
  line-height: 50px;
  margin-top: 30px !important;
  color: #228c4f;
  font-weight: 400;
}
.text {
  padding: 30px;
}
</style>
